export default "__VITE_ASSET__c892ade3__"